import React from "react";

import thumbnail from './bodegon_cuadernos_verano_6cuadernos_arena_tn.jpg';
import Page from '../LandingPage';
import Meta from "../../components/Meta";

const descImg = 'https://res.cloudinary.com/cerebriti/image/upload/v1622014939/LANDING%20VACACIONES%20IMAGENES/juegos_verano_Academons_animado.gif'
const poster = 'https://res.cloudinary.com/cerebriti/image/upload/v1622802861/DESCARGAS%20PDF%20CUADERNOS%20VACACIONES/CUADERNOS%20LANDING/bodegon_cuadernos_verano_6cuadernos_arena.png';

const Home = () => {
    return <>
        <Meta
            title={'Cuaderno de vacaciones gratis para Primaria | Academons'}
            desc={'Cuadernos de vacaciones para descargar gratis de todos los cursos de Primaria. Para niños de 6 a 12 años. Elige un curso y descarga tu cuaderno de verano en PDF con más de 50 actividades para repasar jugando.'}
            h1={'Cuadernos de vacaciones gratis para Primaria'}
            img={thumbnail}
        />
        <Page
            preTitle={'ACTIVIDADES DE REPASO PARA NIÑOS DE PRIMARIA'}
            title={'¡Descarga tu cuaderno de vacaciones gratis!'}
            text={"Este verano tus hijos podrán repasar jugando con nuestros divertidos cuadernos de vacaciones para Primaria. Tienes uno diferente para cada curso, con ejercicios de todas las asignaturas que han aprendido en el colegio. ¡Elige un curso y te lo enviamos gratis!"}
            form={[
                {
                    type: 'select',
                    name: 'schoolYear',
                    label: 'Elige un curso',
                    options: [
                        {value: 'Cuaderno de 1º Primaria', label: 'Cuaderno de 1º Primaria'},
                        {value: 'Cuaderno de 2º Primaria', label: 'Cuaderno de 2º Primaria'},
                        {value: 'Cuaderno de 3º Primaria', label: 'Cuaderno de 3º Primaria'},
                        {value: 'Cuaderno de 4º Primaria', label: 'Cuaderno de 4º Primaria'},
                        {value: 'Cuaderno de 5º Primaria', label: 'Cuaderno de 5º Primaria'},
                        {value: 'Cuaderno de 6º Primaria', label: 'Cuaderno de 6º Primaria'},
                    ]
                },
                {
                    name: 'email',
                    label: 'Escribe tu email',
                    type: 'email'
                }
            ]}
            leagal={'Al introducir tus datos aceptas darte de alta en nuestro boletín educativo, en el que te informaremos de más descargables y otras noticias de Academons.'}
            poster={poster}
            titleSecondary={'¿Qué encontrarás en nuestros cuadernos de verano?'}
            points={[
                <>PDF descargable por curso con más de <b>50 fichas imprimibles diseñadas por docentes.</b></>,
                <>Ejercicios para repasar <b>Matemáticas, Lengua, Ciencias, Inglés y Sociales de Primaria</b></>,
                <><b>Acceso gratuito a nuestra App</b> con más de <b>20.000 actividades</b> educativas</>
            ]}
            descImg={descImg}
        />
    </>
}

export default Home;